export default class Accounts {
  static findByServiceAccountId(accountsData, serviceAccountId) {
    if (!serviceAccountId) return null;

    const normalizedServiceAccountId = `${serviceAccountId}`;

    return accountsData.find(({ id, extraData = {} }) => {
      const { xeroAccountId, zohoAccountId, quickBooksAccountId } = extraData;

      return [id, xeroAccountId, zohoAccountId, quickBooksAccountId]
        .some((accountId) => accountId && `${accountId}` === normalizedServiceAccountId);
    }) || null;
  }
}
